<template>
  <div id="termlyreport">
    <div class="row" v-if="!showPublishTermlyReport">
      <TermlyPost
        :passTermlyReportPostListHeader="termlyReportPostListHeader"
        :ddlFilterPostTypeList="ddlFilterPostTypeList"
        :ddlFilterPostOwnerList="ddlFilterPostOwnerList"
        :ddlFilterTermList="ddlFilterTermList"
        :passTermlyReportPostListHeaderFilter="termlyReportPostListHeaderFilter"
        :termlyReportPostListDetails="termlyReportPostListDetails"
        @addToTermlyReport="addToTermlyReport"
      />

      <div class="col-lg-8 reportArea">
        <div class="row reportAreaTitlePart">
          <div class="col-lg-3 reportAreaTitle"><i class="material-icons">assignment</i> {{ lang('Summative Report') }}</div>
          <div class="col-lg-9 reportAreaTitleButton" v-if="!tourRunning">
            <button class="btnGroupFirst" :class="mode === 'New' && 'btnSelectionActive'" @click="action('New', '')">
              {{ lang('Create New') }}
            </button>
            <!--                        <button class="btnGroupMiddle" :class="showPublishTermlyReport && 'btnSelectionActive'"-->
            <!--                                @click="showPublishedReport()">-->
            <!--                            {{ lang("Published Report") }}-->
            <!--                        </button>-->
            <button class="btnGroupMiddle" :class="mode === 'PendingAction' && 'btnSelectionActive'" @click="action('PendingAction', '')">
              {{ lang('Pending Action') }}
            </button>
            <button class="btnGroupMiddle" :class="mode === 'No' || (mode === 'List' && 'btnSelectionActive')" @click="action('BackToList', '')">
              {{ lang('Report List') }}
            </button>
            <button class="btnGroupLast" @click="$router.push('/TermlyReportHistory')">
              {{ lang('Report History') }}
            </button>
          </div>
          <div class="col-lg-9 reportAreaTitleButton" v-if="tourRunning">
            <button class="btnGroupFirst" id="btnCreateNew" :class="mode === 'New' ? 'btnSelectionActive' : ''">
              {{ lang('Create New') }}
            </button>
            <button class="btnGroupMiddle" id="btnPublishedList" :class="showPublishTermlyReport ? 'btnSelectionActive' : ''">
              {{ lang('Published Report') }}
            </button>
            <button class="btnGroupMiddle" id="btnPendingActionList" :class="mode === 'PendingAction' ? 'btnSelectionActive' : ''">
              {{ lang('Pending Action') }}
            </button>
            <button class="btnGroupMiddle" :class="mode === 'List' || mode === 'No' ? 'btnSelectionActive' : ''">
              {{ lang('Report List') }}
            </button>
            <button class="btnGroupLast">
              {{ lang('Report History') }}
            </button>
          </div>
        </div>
        <div v-if="mode === 'Pending' || mode === 'View' || mode === 'Draft' || mode === 'PendingAction'" class="reportAreaTitlePart">
          <div v-if="mode === 'View'">
            <div style="height: 20px"></div>
          </div>
          <div v-if="mode === 'Pending'">
            <section class="time-line-box">
              <div class="swiper-container text-center">
                <div class="swiper-wrapper">
                  <div v-for="flowDoneItem in flowDone" class="swiper-slide" :key="flowDoneItem.ConName">
                    <div class="timestamp">
                      <span class="date">{{ flowDoneItem.ConName }}</span>
                    </div>
                    <div class="status" :class="{ statusYetDone: flowDoneItem.Done === 'No' }">
                      <span v-if="flowDoneItem.Done === 'Yes'">Submitted</span>
                      <span v-if="flowDoneItem.Done === 'No'">Pending</span>
                    </div>
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </section>
          </div>
        </div>
        <K2Row v-else space-between="true" class="reportAreaContentPart px-3" id="reportAreaContentPart">
          <div style="flex: 1" class="termlyFilter">
            <K2Row align="center">
              <div class="me-3">
                <K2Row align="center" class="mb-2">
                  <K2Text class="lblSelectClass font me-2">{{ lang('Select Class') }} </K2Text>
                  <el-select v-model="ddlClass" :placeholder="lang('Select Class')" class="me-2 pro-edt-select slClass" @change="LoadStudents()" id="ddlClass">
                    <el-option
                      v-for="item in ddlClassList"
                      :key="item.PK_Class_ID"
                      :label="item.CLS_ClassName.trim() + ' ' + item.CLS_Batch.trim()"
                      :value="item.PK_Semester_ID.trim() + ',' + item.SC_FK_CourseID.trim() + ',' + item.PK_Class_ID.trim()"
                    >
                    </el-option>
                  </el-select>
                </K2Row>
                <K2Row v-if="mode === 'List' || mode === 'No'">
                  <el-date-picker
                    style="border: none"
                    v-model="filterByDateRange"
                    type="daterange"
                    :disabled="!selectedClassID"
                    :range-separator="lang('ETo')"
                    :start-placeholder="lang('Start Date')"
                    :end-placeholder="lang('End Date')"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    @change="action('List', '')"
                  >
                  </el-date-picker>
                </K2Row>
              </div>
              <div>
                <K2Row align="center" class="mb-2">
                  <K2Text class="lblSelectStudent font me-2">{{ lang('Select Student') }}</K2Text>
                  <!--<el-select v-model="ddlStudent" :placeholder="lang('Select Student')" class="pro-edt-select slStudent" @change="clear('changeStudent')">-->
                  <el-select
                    v-model="ddlStudent"
                    :placeholder="lang('Select Student')"
                    class="pro-edt-select slStudent me-2"
                    :disabled="!selectedClassID"
                    @change="handleSelectStudent"
                    id="ddlStudent"
                  >
                    <el-option v-for="item in dllStudentList" :key="item.Student_ID" :label="item.Student_Name.trim()" :value="item.Student_ID"> </el-option>
                  </el-select>
                </K2Row>
                <K2Row align="center" v-if="mode === 'List' || mode === 'No'">
                  <K2Text class="lblSelectStudent font me-2">{{ lang('Select Status') }}</K2Text>
                  <!--<el-select v-model="ddlStudent" :placeholder="lang('Select Student')" class="pro-edt-select slStudent" @change="clear('changeStudent')">-->
                  <el-select
                    v-model="selectedStatus"
                    :placeholder="lang('Select Status')"
                    class="pro-edt-select slStudent me-2"
                    :disabled="!selectedClassID"
                    @change="action('List', '')"
                    id="selectedStatus"
                  >
                    <el-option v-for="item in statusList" :key="item" :label="item.trim()" :value="item"> </el-option>
                  </el-select>
                </K2Row>
              </div>
            </K2Row>
          </div>

          <div v-if="mode === 'List' || mode === 'No'">
            <div class="spSearchIcon mb-2" @click="action('ListSearch', '')">
              <i class="material-icons searchIcon">search</i>
            </div>

            <div class="spSearchIcon" :style="{ background: uiVariable.color.secondary }" @click="clear('All')">
              <i class="material-icons searchIcon">refresh</i>
            </div>
          </div>
          <K2Row v-else>
            <div class="spSearchIcon mb-2 me-2" @click="action('ListSearch', '')">
              <i class="material-icons searchIcon">search</i>
            </div>

            <div class="spSearchIcon mb-2" :style="{ background: uiVariable.color.secondary }" @click="clear('All')">
              <i class="material-icons searchIcon">refresh</i>
            </div>
          </K2Row>
        </K2Row>

        <div v-if="mode === 'No'">
          <TermlyModeNo :divEditListRedBorder="divEditListRedBorder" :ddl-class="ddlClass" :ddl-student="ddlStudent" />
        </div>

        <div v-if="mode === 'List'">
          <TermlyModeList
            :termlyReportListInt="termlyReportListInt"
            :tourRunning="tourRunning"
            @action="action"
            @clear="clear"
            :termlyReportList="termlyReportList"
            :divEditListRedBorder="divEditListRedBorder"
            :dllStudentList="dllStudentList"
            :withdrawnStudentList="withdrawnStudentList"
            @updateStudentID="updateStudentID"
          />
        </div>
        <div v-if="mode === 'PendingAction'" class="row reportAreaContentPart2">
          <TermlyModePending
            :pendingActionListInt="pendingActionListInt"
            :passInputSearchPendingList="inputSearchPendingList"
            :mode="mode"
            :ddlClass="ddlClass"
            @action="action"
            :pendingActionList="pendingActionList"
            @bulkApproval="signTermlyReportComments"
          />
        </div>
        <div v-if="mode === 'New' || mode === 'Pending' || mode === 'View' || mode === 'Draft'" class="row reportAreaContentPart2">
          <TermlyContent
            :currentEditor="currentEditor"
            :mode="mode"
            :ddlClass="ddlClass"
            :ddlClassList="ddlClassList"
            :tourRunning="tourRunning"
            :termlyReportListInt="termlyReportListInt"
            @action="action"
            :currentClassStudentName="currentClassStudentName"
            :nextSave="nextSave"
            @submitTermlyReport="submitTermlyReport"
            @updateTermlyReport="updateTermlyReport"
            :nextTurn="nextTurn"
            :userID="userID"
            @signTermlyReportComments="signTermlyReportComments"
            @publishTermlyReport="publishTermlyReport"
            :allowPublish="allowPublish"
            :teacherAndApproverList="teacherAndApproverList"
            @adddeleteLanguageTeacher="adddeleteLanguageTeacher"
            :userMain="userMain"
            :passUserFlow="userFlow"
            :autoGenerateTitle="autoGenerateTitle"
            @getTermlyReport="getTermlyReport"
            :passTermlyReportDomainComment="termlyReportDomainComment"
            @updateComment="updateComment"
            :studentInfoPart="studentInfoPart"
            :passTermlyReportContent="termlyReportContent"
            :passTermlyReportHeader="termlyReportHeader"
            :passTermlyReportHeaderCN="termlyReportHeaderCN"
            :groupDomainMapChinese="groupDomainMapChinese"
            :passGroupDomain="groupDomain"
            :checkSubmit="checkSubmit"
            :passSingleComment="singleComment"
            :currentTermlyReportID="currentTermlyReportID"
            :ddlStudent="ddlStudent"
            :ddlStudentInfo="ddlStudentInfo"
            :selectedTeacherList="selectedTeacherList"
            :dllStudentList="dllStudentList"
            @clear="clear"
            :allowEditUser="allowEditUser"
            :termlyReportPublish="termlyReportPublish"
            :dsKgm_TermlyReport="dsKgm_TermlyReport"
          />
        </div>
      </div>
    </div>
    <div v-if="showPublishTermlyReport" style="padding: 20px">
      <div style="text-align: left">
        <button class="btnGroupMiddle btnSelectionActive" @click="hidePublishedReport()">
          {{ lang('Back') }}
        </button>
      </div>
      <staffTermlyReportList />
    </div>
    <v-tour name="termlyReportTourName" :steps="termlyReportTour" :options="termlyReportTourOptions" :callbacks="termlyReportTourCallBacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button class="v-step__button" @click="termlyReportNexPreviousStep(tour, 'Stop')">Skip</button>
                <button class="v-step__button" @click="termlyReportNexPreviousStep(tour, 'Next')">Next</button>
              </div>
            </template>
            <template v-if="tour.currentStep !== 0 && tour.currentStep + 1 !== tour.steps.length">
              <div slot="actions">
                <button class="v-step__button" @click="termlyReportNexPreviousStep(tour, 'Stop')">Skip</button>
                <button class="v-step__button" @click="termlyReportNexPreviousStep(tour, 'Previous')">Previous</button>
                <button class="v-step__button" @click="termlyReportNexPreviousStep(tour, 'Next')">Next</button>
              </div>
            </template>
            <template v-if="tour.currentStep + 1 === tour.steps.length">
              <div slot="actions">
                <button class="v-step__button" @click="termlyReportNexPreviousStep(tour, 'Stop')">Skip</button>
                <button class="v-step__button" @click="termlyReportNexPreviousStep(tour, 'Previous')">Previous</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <v-tour name="termlyReportEditTourName" :steps="termlyReportEditTour" :options="termlyReportEditTourOptions" :callbacks="termlyReportEditTourCallBacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button class="v-step__button" @click="termlyReportEditNexPreviousStep(tour, 'Stop')">Skip</button>
                <button class="v-step__button" @click="termlyReportEditNexPreviousStep(tour, 'Next')">Next</button>
              </div>
            </template>
            <template v-if="tour.currentStep !== 0 && tour.currentStep + 1 !== tour.steps.length">
              <div slot="actions">
                <button class="v-step__button" @click="termlyReportEditNexPreviousStep(tour, 'Stop')">Skip</button>
                <button class="v-step__button" @click="termlyReportEditNexPreviousStep(tour, 'Previous')">Previous</button>
                <button class="v-step__button" @click="termlyReportEditNexPreviousStep(tour, 'Next')">Next</button>
              </div>
            </template>
            <template v-if="tour.currentStep + 1 === tour.steps.length">
              <div slot="actions">
                <button class="v-step__button" @click="termlyReportEditNexPreviousStep(tour, 'Stop')">Skip</button>
                <button class="v-step__button" @click="termlyReportEditNexPreviousStep(tour, 'Previous')">Previous</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>

<script>
import DataSource from '../../data/datasource'
import Cookies from 'js-cookie'
import { lang } from '../../locale'
import Vue from 'vue'
import staffTermlyReportList from '../StaffTermlyReportList'
import VueTour from 'vue-tour'
import TermlyPost from './component/termlyPost'
import TermlyModeNo from './component/termlyModeNo'
import TermlyModeList from './component/termlyModeList'
import TermlyModePending from './component/termlyModePending'
import TermlyContent from './component/termlyContent'
import K2Row from '../../uiComponents/k2Row/k2Row'
import K2Text from '../../uiComponents/k2Text/k2Text'
import uiVariable from '../../config/uiVariable'
import { getAge, getFormatDate } from '@/helper/utily'
import { getRole, getUserID } from '@/helper/util_custom'
import store from '@/global'

require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

export default {
  name: 'TermlyReport',
  components: {
    K2Text,
    K2Row,
    TermlyContent,
    TermlyModePending,
    TermlyModeList,
    TermlyModeNo,
    TermlyPost,
    staffTermlyReportList,
  },
  data() {
    return {
      showPublishTermlyReport: false,
      uiVariable: uiVariable,
      userID: '',
      ddlStudent: null,
      ddlStudentInfo: null,
      dllStudentList: [],
      withdrawnStudentList: [],
      ddlClass: '',
      reportLevel: '',
      selectedClassID: '',
      ddlClassList: [],
      selectedStatus: null,
      statusList: ['Draft', 'Published', 'Pending', 'Rejected'],
      mode: 'No',
      currentClassStudentName: '',
      currentTermlyReportID: '',
      nextTurn: false,
      userMain: false,
      userFlow: [],
      nextSave: false,
      currentEditor: null,

      ddlClassTeacher: '',
      classTeacherList: [],
      inputTeacherType: '',
      checkedTeacher: false,
      checkSubmit: false,

      selectedTeacherList: [],
      selectedTeacherListColumn: [
        {
          prop: 'Name',
          label: 'Name',
        },
        {
          prop: 'Type',
          label: 'Role',
        },
      ],

      termlyReportPostListHeader: [],
      termlyReportPostListHeaderFilter: [],
      termlyReportPostListDetails: [],
      filterPostTitle: '',

      termlyReportListInt: [],
      termlyReportList: [
        { prop: 'StudentName', label: lang('Student Name') },
        { prop: 'Title', label: lang('Title') },
        { prop: 'TeRpCreatedOn_edited', label: lang('Date') },
      ],

      termlyReportHeader: '',
      termlyReportHeaderCN: '',
      termlyReportContent: '',
      groupDomain: [
        { Domain: 'The Child as Communicator' },
        { Domain: 'The Child in a Social-Cultural Context' },
        { Domain: 'The Thinking Child' },
        { Domain: 'The Physical Child' },
        { Domain: 'The Child as an Agent of Change' },
      ],
      groupDomainMapChinese: {},
      termlyReportDomainComment: [],
      dsKgm_TermlyReport: [],
      autoGenerateTitle: '',
      flowDone: [],

      studentInfoPart: {},
      // studentInfoPartName: "",
      // studentInfoPartAge: "",
      // studentInfoPartDob: "",
      // studentInfoJoinDate: "",
      // studentInfoPartClass: "",
      teacherAndApproverList: [],
      allowEditUser: [],
      ddlFilterPostType: '',
      ddlFilterPostTypeList: [{ Selection: '' }, { Selection: 'Moments' }, { Selection: 'NewsFeed' }],
      ddlFilterPostOwner: '',
      ddlFilterPostOwnerList: [],
      ddlFilterTerm: '',
      ddlFilterTermList: [],

      singleComment: '',

      linkID: '',

      allowPublish: false,
      termlyReportPublish: null,
      pendingActionListInt: [],
      pendingActionList: [
        { prop: 'Title', label: lang('Title') },
        { prop: 'CreatedDate_edit', label: lang('Date') },
        { prop: 'convertSubmitDate', label: lang('Submitted Date') },
        { prop: 'ClassName', label: lang('Class') },
        { prop: 'LevelName', label: lang('Level') },
        { prop: 'StudentName', label: lang('Student Name') },
        { prop: 'StatusLabel', label: lang('Status') },
      ],

      inputSearchPendingList: '',
      filterByDateRange: null,
      //vue tour
      tourRunning: false,
      divEditListRedBorder: false,

      termlyReportTourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },
      termlyReportTourCallBacks: {
        // onPreviousStep: this.studentPageUpdateLevelClassVueTourCallBacksPreviousSteps,
        // onNextStep: this.studentPageUpdateLevelClassVueTourCallBacksNextSteps
      },
      termlyReportTour: [
        {
          target: '#ddlClass',
          content: `<div class="studentPageTourDiv">Step 1 / 7 <br>Select Class</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#ddlStudent',
          content: `<div class="studentPageTourDiv">Step 2 / 7 <br>Select Student</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#btnCreateNew',
          content: `<div class="studentPageTourDiv">Step 3 / 7 <br>Click Create New button</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#reportAreaContentPart',
          content: `<div class="studentPageTourDiv">Step 4 / 7 <br>New Summative Report Page</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#divVerficationTeacherTitle',
          content: `<div class="studentPageTourDiv">Step 5 / 7 <br>Verify Teacher & Coordinator & Principal</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#divNewTitle',
          content: `<div class="studentPageTourDiv">Step 6 / 7 <br>Fill the page fields, can leave blank for draft</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#btnNewDraft',
          content: `<div class="studentPageTourDiv">Step 7 / 7 <br>Click Draft button to save as draft</div>`,
          params: {
            placement: 'top',
          },
        },
      ],

      termlyReportEditTourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },
      termlyReportEditTourCallBacks: {
        // onPreviousStep: this.studentPageUpdateLevelClassVueTourCallBacksPreviousSteps,
        // onNextStep: this.studentPageUpdateLevelClassVueTourCallBacksNextSteps
      },
      termlyReportEditTour: [
        {
          target: '#ddlClass',
          content: `<div class="studentPageTourDiv">Step 1 / 7 <br>Select Class</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#ddlStudent',
          content: `<div class="studentPageTourDiv">Step 2 / 7 <br>Select Student</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#divEditList',
          content: `<div class="studentPageTourDiv">Step 3 / 7 <br>Active Status<br>Approved<br>click and go into next page, download and publish function available</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#divEditList',
          content: `<div class="studentPageTourDiv">Step 4 / 7 <br>Pending Status<br>Pending Approval<br>click and go into next page, view approval status and approve action</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#divEditList',
          content: `<div class="studentPageTourDiv">Step 5 / 7 <br>Draft Status<br>In progress of writing Summative Report<br>click and go into next page, writing Summative Report</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#btnPublishedList',
          content: `<div class="studentPageTourDiv">Step 6 / 7 <br>View published Summative Report</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#btnPendingActionList',
          content: `<div class="studentPageTourDiv">Step 7 / 7 <br>View all the pending action<br>in the list, click the button at right hand side to continue the action</div>`,
          params: {
            placement: 'top',
          },
        },
      ],
      //vue tour
    }
  },
  props: ['passTermlyReportID', 'passTourData'],
  created() {
    store.dispatch('devAccess/refreshIsLocalDevUser')
    this.init()
  },
  async mounted() {
    this.userID = getUserID()

    if (this.$route.query.termlyreportid !== undefined) {
      this.linkID = this.$route.query.termlyreportid
    }

    if (this.linkID !== '') {
      this.$router.replace({ query: null })

      let result = await this.getTermlyReportInfoByLink(this.linkID)
      this.ddlStudent = result.Table[0].StudentID
      this.ddlClass = '0,0,' + result.Table[0].ClassID

      this.action('Pending', result.Table[0].TermlyReportID)
    }

    if (this.passTourData === 'termlyreport') {
      this.termlyReportTourStart()
    } else if (this.passTourData === 'termlyreportEdit') {
      this.termlyReportEditTourStart()
    }
  },
  methods: {
    lang,
    async init() {
      this.$vs.loading()
      await this.BindClasses()
      await this.getClassTeacher()
      await this.GetTermlyReportDomainMapping()
      this.$vs.loading.close()
    },
    updateStudentID(studentID) {
      this.ddlStudent = studentID
    },
    async GetTermlyReportDomainMapping() {
      try {
        // groupDomainMapChinese: {
        //     '善交流的儿童' : 'The Child as Communicator',
        //     '社会文化中的儿童' : 'The Child in a Social-Cultural Context',
        //     '好思考的儿童' : 'The Thinking Child',
        //     '身体健康的儿童' : 'The Physical Child',
        //     '与时俱进的儿童' : 'The Child as an Agent of Change',
        // },
        let tempGroupDomainMapChinese = {}

        const response = await DataSource.shared.getTermlyReportDomainMapping()
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report Domain Mapping: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report Domain Mapping: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            response.Table.forEach(m => {
              Vue.set(tempGroupDomainMapChinese, m.PlnDpMmSub, m.PlnDpMmMain)
            })

            this.groupDomainMapChinese = tempGroupDomainMapChinese
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async BindClasses() {
      try {
        const response = await DataSource.shared.getAttendanceClass()
        if (response) {
          if (response.code === '2') {
            console.log('Get Attendance Class: No Record')
          } else if (response.code === '99') {
            console.log('Get Attendance Class: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.ddlClassList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async LoadListbyDate() {
      try {
        this.clear('changeClass')
        this.action('List', '')
      } catch (e) {
        this.results = e
      }
    },
    async LoadStudents() {
      try {
        this.clear('changeClass')
        if (this.ddlClass) {
          let classID = this.ddlClass.split(',')
          this.selectedClassID = classID[2]
        }
        this.$vs.loading()
        await this.loadActiveStudent()
        await this.loadWithdrawnStudent()
        this.$vs.loading.close()
        this.checkIsList()
      } catch (e) {
        this.results = e
      }
    },
    async loadActiveStudent() {
      const response = await DataSource.shared.LoadAttendanceList(this.ddlClass)
      if (response) {
        if (response.code === '2') {
          this.$notify.error({
            title: 'Error',
            message: 'No Student Found...',
          })
        } else if (response.code === '99') {
          console.log('Load Attendance List: Error')
        } else if (response.code === '88') {
          window.location.replace('/')
        } else {
          this.dllStudentList = response.Table
        }
      }
    },
    async loadWithdrawnStudent() {
      const response = await DataSource.shared.LoadAttendanceList(this.ddlClass, 'Active,Withdrawn')
      if (response) {
        if (response.code === '2') {
          console.log('no withdrawn student...')
          // this.$notify.error({
          //   title: "Error",
          //   message: "No Student Found..."
          // });
        } else if (response.code === '99') {
          console.log('Load Attendance List: Error')
        } else if (response.code === '88') {
          window.location.replace('/')
        } else {
          this.withdrawnStudentList = response.Table
        }
      }
    },
    handleSelectStudent() {
      this.ddlStudentInfo = this.dllStudentList.find(d => d.Student_ID === this.ddlStudent)
      this.checkIsList()
    },
    checkIsList() {
      if (this.mode !== 'NewSelectStudent' && this.mode !== 'New') {
        this.action('List', '')
      }
    },
    async getClassTeacher() {
      try {
        const response = await DataSource.shared.getTeacherListBySchool()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.classTeacherList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async handleLoadTermlyReporList() {
      this.$vs.loading()
      await this.LoadTermlyReporList()
      this.$vs.loading.close()
    },
    async LoadTermlyReporList(type) {
      try {
        let dateFrom, dateTo, studentID
        if (this.filterByDateRange && this.filterByDateRange.length) {
          dateFrom = this.filterByDateRange[0]
          dateTo = this.filterByDateRange[1]
        }
        if (this.ddlStudent !== '' && type !== 'class') {
          studentID = this.ddlStudent
        }
        const response = await DataSource.shared.getTermlyReportList(studentID, this.selectedClassID, dateFrom, dateTo, this.selectedStatus)
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report List: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report List: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            response.Table.forEach(d => {
              const student = this.dllStudentList.find(x => x.Student_ID === d.TeRpStudentID)
              if (student) {
                d.StudentName = student.Student_Name
              }
              d.TeRpCreatedOn_edited = getFormatDate(d.TeRpCreatedOn, 'YYYY/MM/DD')
              d.convertSubmitDate = getFormatDate(d.TeRpSubmittedOn, 'YYYY/MM/DD')
              if (d.TeRpStatus === 'Draft' && d.convertSubmitDate) {
                d.TeRpStatus = 'Reject'
              }
              if (d.TeRpStatus === 'Active') {
                d.TeRpStatus = lang('Published')
              }
            })
            this.termlyReportListInt = response.Table
          }
        }
      } catch (e) {
        this.results = e
        console.log(e, 'error')
      }
    },
    async GetTermlyReporPostList() {
      try {
        this.$vs.loading()

        let currentClassID = this.ddlClass.split(',')

        const response = await DataSource.shared.getTermlyReportPostList(this.ddlStudent, currentClassID[2])
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report Post List: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report Post List: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            if (response.Header.length > 0) {
              this.termlyReportPostListHeader = response.Header

              //set default blank for filter post owner and post term
              let tempObject = {}

              tempObject = {
                Name: '',
              }
              this.ddlFilterPostOwnerList.push(tempObject)

              tempObject = {
                Term: '',
              }
              this.ddlFilterTermList.push(tempObject)
              //set default blank for filter post owner and post term

              this.termlyReportPostListHeader = this.termlyReportPostListHeader.map(m => {
                //group post owner name
                let checkOwner = this.ddlFilterPostOwnerList.filter(m2 => m2.Name === m.CreatorName)
                if (checkOwner.length < 1) {
                  tempObject = {
                    Name: m.CreatorName,
                  }

                  this.ddlFilterPostOwnerList.push(tempObject)
                }
                //group post owner name

                //group post term
                let checkTerm = this.ddlFilterTermList.filter(m2 => m2.Term === m.PostTerm)
                if (checkTerm.length < 1) {
                  tempObject = {
                    Term: m.PostTerm,
                  }

                  this.ddlFilterTermList.push(tempObject)
                }
                //group post term

                m.Active = true

                return m
              })

              this.termlyReportPostListHeaderFilter = this.termlyReportPostListHeader
            }

            if (response.Details.length > 0) {
              this.termlyReportPostListDetails = response.Details

              this.termlyReportPostListDetails = this.termlyReportPostListDetails.map(m => {
                m.Active = true

                return m
              })
            }
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },

    async getTermlyReport(termlyReportID) {
      this.termlyReportHeader = ''
      this.termlyReportHeaderCN = ''
      try {
        const response = await DataSource.shared.getTermlyReport(termlyReportID)
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.dsKgm_TermlyReport = response?.dsKgm_TermlyReport?.Table
            this.ddlStudentInfo = this.dllStudentList.find(d => d.Student_ID === response?.dsKgm_TermlyReport?.Table?.[0]?.TeRpStudentID)
            if (this.mode === 'Draft') {
              //check if user is main or creator
              response.dsFlow.Flow.forEach(m => {
                if (m.ConID === this.userID) {
                  this.currentEditor = m
                  this.nextSave = true
                  if (m.Type === 'Creator' || m.Type === 'Main') {
                    this.userMain = true

                    if (m.Type === 'Creator') {
                      this.checkSubmit = true
                    }
                  }
                }
              })
              //check if user is main or creator
              //main table to user flow
              this.userFlow = response.dsFlow.Flow
              //main table to user flow
              this.autoGenerateTitle = response?.SEMD_DetailName
              //main table to for comment
              this.termlyReportDomainComment = response.dsKgm_TermlyReportComment.Table

              this.termlyReportDomainComment = this.termlyReportDomainComment.map(m => {
                m.editComment = false
                m.editCommentValue = ''
                return m
              })
              //main table to for comment

              //set header if user if main or creator
              if (this.userMain) {
                this.termlyReportDomainComment.forEach(m => {
                  if (m.TeRpCMConID === this.userID) {
                    if (m.TeRpCMType === 'Header') {
                      this.termlyReportHeader = m.TeRpCMComment
                    } else if (m.TeRpCMType === 'Content') {
                      this.termlyReportContent = m.TeRpCMComment
                    }
                  }
                })
                let headerCNFound = this.termlyReportDomainComment?.find(d => d.TeRpCMType === 'HeaderCN')
                if (!headerCNFound) {
                  headerCNFound = this.termlyReportDomainComment?.find(d => d.TeRpCMDomain === 'HeaderCN')
                }
                this.termlyReportHeaderCN = headerCNFound?.TeRpCMConID === this.userID ? headerCNFound?.TeRpCMComment : null
              }
              //set header if user if main or creator

              //set all domains if user if main or creator
              if (this.userMain) {
                this.termlyReportDomainComment.forEach(m => {
                  if (m.TeRpCMType === 'Domain' && m.TeRpCMConID === this.userID) {
                    this.groupDomain.forEach(m2 => {
                      if (m2.Domain === m.TeRpCMDomain) {
                        m2.Comment = m.TeRpCMComment
                      }
                    })
                  }
                })
              }
              //set all domains if user if main or creator

              //set single comment for non main
              if (!this.userMain) {
                this.termlyReportDomainComment.forEach(m => {
                  if (m.TeRpCMType === 'Single' && m.TeRpCMConID === this.userID) {
                    this.singleComment = m.TeRpCMComment
                  }
                })
              }
              //set single comment for non main
            } else if (this.mode === 'Pending' || this.mode === 'View') {
              this.userFlow = response.dsFlow.Flow
              this.termlyReportDomainComment = response.dsKgm_TermlyReportComment.Table

              this.termlyReportDomainComment = this.termlyReportDomainComment.map(m => {
                m.editComment = false
                m.editCommentValue = ''
                return m
              })
              this.allowPublish = response.dsKgm_TermlyReport.Table[0].TeRpCreatedBy === this.userID && getRole() !== 'Teacher'
            }

            if (response?.TermlyReportPublish) {
              this.termlyReportPublish = response?.TermlyReportPublish?.Table?.[0]
            }
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async checkTermlyReportFlow(termlyReportID) {
      try {
        let currentClassID = this.ddlClass.split(',')

        const response = await DataSource.shared.checkTermlyReportFlow(termlyReportID, currentClassID[2])
        if (response) {
          if (response.code === '1') {
            this.nextTurn = true
          } else if (response.code === '2') {
            this.nextTurn = false
          } else if (response.code === '99') {
            console.log('Check Summative Report Flow: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            window.location.replace('/')
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getTermlyReportFlow() {
      try {
        this.$vs.loading()

        let currentClassID = this.ddlClass.split(',')
        let tempAllowEditUser = []

        const response = await DataSource.shared.getTermlyReportFlow(this.currentTermlyReportID, currentClassID[2])
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report Flow: No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report Flow: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            response.Table.forEach(m => {
              if (m.Done === 'No') {
                tempAllowEditUser.push(m)
              }
            })
            this.allowEditUser = tempAllowEditUser
            this.flowDone = response.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async getTermlyReportStudentInfoPart() {
      try {
        let currentClassID = this.ddlClass.split(',')
        let tempAllowEditUser = []
        const response = await DataSource.shared.getTermlyReportStudentInfoPart(this.ddlStudent, currentClassID[2])
        if (response) {
          if (response.code === '2') {
            console.log('Get Summative Report Student Info Part : No Record')
          } else if (response.code === '99') {
            console.log('Get Summative Report Student Info Part : Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            // this.studentInfoPartName = response.ds.Table[0].Name;
            // this.studentInfoPartAge = response.ds.Table[0].Age;
            let age = getAge(response.ds.Table[0].Dob)
            // this.studentInfoPartAge = age.years + " years " + age.months + " months";
            // this.studentInfoPartDob = response.ds.Table[0].Dob;
            // this.studentInfoJoinDate = response.ds.Table[0].Regst_Date;

            this.teacherAndApproverList = response.dsTeacherAndApprover.Table
            this.teacherAndApproverList.forEach(m => {
              if (m.Role === 'Coordinator' || m.Role === 'Principal') {
                tempAllowEditUser.push(m)
              }
              if (m.Role === 'Mandarin Teacher' || m.Role === 'Coordinator' || m.Role === 'Principal') {
                m.RoleType = 'NonLanguageTeacher'
                m.RoleTypeActive = 'Yes'
              } else {
                m.RoleType = 'LanguageTeacher'
                m.RoleTypeActive = 'Yes'
              }
            })
            this.allowEditUser = tempAllowEditUser
            let currentClassID = this.ddlClass.split(',')
            let currentClassName = this.ddlClassList.filter(m => m.PK_Class_ID === currentClassID[2])
            // this.studentInfoPartClass = currentClassName[0].CLS_ClassName;
            let firstStudent = response?.ds?.Table?.[0]
            this.studentInfoPart = {
              name: firstStudent?.Name,
              age: age?.years + ' year(s) ' + age?.months + ' month(s)',
              dob: firstStudent?.Dob,
              joinDate: firstStudent?.Regst_Date,
              class: currentClassName?.[0]?.CLS_ClassName,
              semdFrom: firstStudent?.SEMD_FromDate,
              semdTo: firstStudent?.SEMD_ToDate,
              SEMD_DetailName: firstStudent?.SEMD_DetailName,
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async submitTermlyReport() {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.submitTermlyReport(this.currentTermlyReportID)
        if (response) {
          if (response.code === '99') {
            console.log('Submit Summative Report: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'Required',
              message: 'Pending action from teacher...',
            })
          } else {
            this.$notify({
              title: 'Submitted',
              message: 'Summative Report Submitted...',
            })

            this.clear('All')
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async signTermlyReportComments(value, selectedReports) {
      this.$vs.loading()
      let selectedReportArr = []
      if (selectedReports) {
        selectedReports?.forEach(d => {
          selectedReportArr?.push(d?.TermlyReportID)
        })
      } else {
        selectedReportArr?.push(this.currentTermlyReportID)
      }

      const response = await DataSource.shared.signTermlyReportComments(JSON.stringify(selectedReportArr), value)
      if (response) {
        if (response.code === '99' || response?.code === '2') {
          this.$notify({
            title: lang('Error'),
            message: lang('Sign Summative Report Comments: Error'),
            type: 'error',
          })
        } else if (response.code === '88') {
          window.location.replace('/')
        } else {
          this.$notify({
            title: 'Signed',
            message: value === 'Reject' ? 'Summative Report Rejected...' : 'Summative Report Signed...',
          })
          this.clear('All')
        }
      }
      this.$vs.loading.close()
    },
    async getTermlyReportInfoByLink(inputString) {
      try {
        const response = await DataSource.shared.getTermlyReportInfoByLink(decodeURI(inputString))
        if (response) {
          if (response.code === '99') {
            console.log('Get Summative Report Info By Link : Error')
            return ''
          } else if (response.code === '88') {
            window.location.replace('/')
            return ''
          } else {
            return response
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async updateTermlyReport(mode) {
      try {
        if (mode === 'Delete') {
          this.$vs.loading()

          const response = await DataSource.shared.updateTermlyReport(this.currentTermlyReportID, mode)
          if (response) {
            if (response.code === '99') {
              console.log('Update Summative Report : Error')
              return ''
            } else if (response.code === '88') {
              window.location.replace('/')
              return ''
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Invalid',
                message: 'Invalid Action...',
              })
            } else {
              this.clear('All')
            }
          }

          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async publishTermlyReport() {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.publishTermlyReport(this.currentTermlyReportID)
        if (response) {
          if (response.code === '99') {
            console.log('Publish Summative Report: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'Invalid',
              message: 'Unauthorized Publish...',
            })
          } else if (response.code === '3') {
            this.$notify({
              title: 'Duplicated',
              message: 'This Summative Report Have Published Before...',
            })
          } else {
            this.$notify({
              title: 'Successful',
              message: 'Summative Report Successfully Published...',
            })
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async updateComment(value) {
      try {
        if (value.editCommentValue === '') {
          this.$notify.error({
            title: 'Required',
            message: 'Edit Comment Required...',
          })
        } else {
          this.$vs.loading()

          const response = await DataSource.shared.updateTermlyReportCommentsByApproval(value.TeRpCMTeRpID, value.TeRpCMID, value.editCommentValue)

          if (response) {
            switch (response?.code) {
              case '1':
                this.$notify({
                  title: 'Successfully',
                  message: 'Successfully Edited...',
                })
                await this.action(this.mode, this.currentTermlyReportID)
                break
              case '88':
                window.location.replace('/')
                break
              default:
                this.$notify.error({
                  title: 'Error',
                  message: response?.message,
                })
            }
          }

          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async getTermlyReportPendingActionList() {
      try {
        this.$vs.loading()

        this.pendingActionListInt = []

        const response = await DataSource.shared.getTermlyReportPendingActionList()
        if (response) {
          if (response.code === '99') {
            console.log('Get Summative Report Pending Action List: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            if (response.dsPendingComment.Table.length > 0) {
              response.dsPendingComment.Table.forEach(m => {
                this.pendingActionListInt.push(m)
              })
            }

            if (response.dsPendingApprove.Table.length > 0) {
              response.dsPendingApprove.Table.forEach(m => {
                this.pendingActionListInt.push(m)
              })
            }

            this.pendingActionListInt.forEach(d => {
              d.convertSubmitDate = getFormatDate(d.TeRpSubmittedOn, 'YYYY/MM/DD', 'DD/MM/YYYY hh:mm:ss')
              d.CreatedDate_edit = getFormatDate(d.CreatedDate, 'YYYY/MM/DD', 'DD/MM/YYYY')
              if (d.Status === 'Draft' && d.convertSubmitDate) {
                d.Status = 'Reject'
              }
              d.StatusLabel = lang(d?.Status)
            })
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    resetGroupDomain() {
      this.groupDomain = [
        { Domain: 'The Social Child 社会背景下的儿童' },
        { Domain: 'The Child as a Communicator (English) 善交流的儿童（英文）' },
        { Domain: 'The Child as a Communicator (Mandarin) 善交流的儿童（华文）' },
        { Domain: 'Online Translation of "The Child as a Communicator (Mandarin)" “善交流的儿童（华文）”在线翻译' },
        { Domain: 'The Thinking Child 好思考的儿童' },
        { Domain: 'The Physical Child 身体健康的儿童' },
        this.isInfantCare ? null : { Domain: 'Creative Expression and Enjoyment through the Arts 通过艺术创意表达，并享受艺术' },
        this.isInfantCare ? null : { Domain: 'The Child as an Agent of Change 与时俱进的儿童' },
      ].filter(Boolean)
    },
    clear(value) {
      this.termlyReportListInt = []
      this.termlyReportPostListHeader = []
      this.termlyReportPostListDetails = []
      this.termlyReportHeader = ''
      this.termlyReportContent = ''
      this.termlyReportDomainComment = []
      this.currentTermlyReportID = ''
      this.nextTurn = false
      this.flowDone = []
      this.studentInfoPart = {}
      this.ddlFilterPostType = ''
      this.filterPostTitle = ''
      this.ddlClassTeacher = ''
      this.inputTeacherType = ''
      this.selectedTeacherList = []
      this.checkedTeacher = false
      this.userMain = false
      this.userFlow = []
      this.nextSave = false
      this.singleComment = ''
      this.checkSubmit = false
      this.ddlFilterPostOwner = ''
      this.ddlFilterPostOwnerList = []
      this.ddlFilterTerm = ''
      this.ddlFilterTermList = []
      this.teacherAndApproverList = []
      this.allowPublish = false
      this.pendingActionListInt = []
      this.resetGroupDomain()

      if (value === 'All') {
        this.dllStudentList = []
        this.ddlStudent = ''
        this.ddlClass = ''
        this.selectedClassID = null
        this.filterByDateRange = null
        this.selectedStatus = null
        this.mode = 'No'
      } else if (value === 'changeStudent') {
        this.mode = 'No'
        this.fnCurrentClassStudentName()
      } else if (value === 'changeClass') {
        this.dllStudentList = []
        this.ddlStudent = ''
        if (this.mode !== 'NewSelectStudent') {
          this.mode = 'No'
        }
      } else if (value === 'changeAction') {
      }
    },
    async checkIsCurrentClassTeacher() {
      let classArray = this.ddlClass?.split(',')
      let response = await DataSource.shared.getCreateTermlyClassTeacher(classArray?.[2])
      if (response) {
        return getUserID() === response?.[0]?.CLS_Class_Incharge_Staff
      }
    },
    async action(value, termlyReportID, TeRpStudentID) {
      if (TeRpStudentID) {
        this.ddlStudent = TeRpStudentID
      }
      if (value === 'PendingActionNext') {
        let checkPendingAction = this.pendingActionListInt.filter(m => m.TermlyReportID === termlyReportID)
        if (checkPendingAction.length > 0) {
          switch (checkPendingAction[0].Status) {
            case 'Reject':
            case 'Rejected':
              checkPendingAction[0].Status = 'Draft'
              break
            case 'Publish':
            case 'Published':
              checkPendingAction[0].Status = 'Active'
              break
          }
          value = checkPendingAction[0].Status
          this.ddlStudent = checkPendingAction[0].StudentID
          this.ddlClass = 'Error,Error,' + checkPendingAction[0].ClasID
          this.reportLevel = checkPendingAction[0]?.LevelID
        } else {
          return
        }
      }
      if (value === 'New') {
        let isClassTeacher = this.isLocalDevUser || (await this.checkIsCurrentClassTeacher())
        if (!isClassTeacher && this.ddlStudent !== null) {
          this.$notify.error({
            title: 'Error',
            message: 'Create new is denied, please check with class teacher....',
          })
        } else if (this.ddlClass === '' || this.ddlStudent === '') {
          if (this.ddlClass !== '' && this.ddlStudent === '') {
          } else {
            this.$notify({
              title: 'Required',
              message: 'Please select student....',
            })
          }

          this.mode = 'NewSelectStudent'
        } else if (this.ddlClass.toUpperCase().includes('ERROR')) {
          this.ddlClass = null
          this.ddlStudent = null
          this.$notify({
            title: 'Required',
            message: 'Please select student....',
          })
          this.mode = 'NewSelectStudent'
        } else {
          this.mode = 'New'

          this.clear('changeAction')
          this.LoadTermlyReporList('class')
          this.GetTermlyReporPostList()
          this.getTermlyReportStudentInfoPart()
        }
      } else if (this.mode === 'NewSelectStudent' && value === 'New') {
        if (this.ddlClass === '' && this.ddlStudent === '') {
          this.$notify({
            title: 'Required',
            message: 'Please select student....',
          })
        } else {
          this.mode = 'New'
          let isClassTeacher = this.isLocalDevUser || (await this.checkIsCurrentClassTeacher())
          if (isClassTeacher) {
            this.clear('changeAction')
            this.LoadTermlyReporList()
            this.GetTermlyReporPostList()
            this.getTermlyReportStudentInfoPart()
          }
        }
      } else if (value === 'List') {
        this.mode = 'List'
        this.clear('changeAction')
        this.handleLoadTermlyReporList()
      } else if (value === 'Active') {
        this.mode = 'View'
        this.clear('changeAction')
        this.currentTermlyReportID = termlyReportID
        this.getTermlyReport(termlyReportID)
        this.getTermlyReportStudentInfoPart()
      } else if (value === 'Pending') {
        this.mode = 'Pending'
        this.clear('changeAction')
        this.currentTermlyReportID = termlyReportID
        this.getTermlyReport(termlyReportID)
        this.checkTermlyReportFlow(termlyReportID)
        this.GetTermlyReporPostList()
        this.getTermlyReportFlow()
        this.getTermlyReportStudentInfoPart()
      } else if (value === 'Draft') {
        this.mode = 'Draft'
        // this.ddlStudent = null;
        // this.ddlClass = "";
        this.clear('changeAction')
        this.currentTermlyReportID = termlyReportID
        this.getTermlyReport(termlyReportID)
        this.GetTermlyReporPostList()
        this.getTermlyReportStudentInfoPart()
        this.handleLoadTermlyReporList()
      } else if (value === 'BackToList') {
        this.clear('All')
        this.mode = 'List'
      } else if (value === 'PendingAction') {
        this.mode = 'PendingAction'
        this.clear('changeAction')
        this.getTermlyReportPendingActionList()
      }
    },
    addToTermlyReport(row) {
      let mapDomain = row.Domain
      if (this.groupDomainMapChinese.hasOwnProperty(row.Domain)) {
        mapDomain = this.groupDomainMapChinese[row.Domain] + ' ' + row.Domain
      }
      if (row.Domain?.includes('善交流的儿童')) {
        mapDomain = 'The Child as a Communicator (Mandarin) 善交流的儿童（华文）'
      } else if (row.Domain?.includes('The Child as Communicator')) {
        mapDomain = 'The Child as a Communicator (English) 善交流的儿童（英文）'
      } else {
        let exist
        if (Object.keys(this.groupDomainMapChinese)?.length) {
          exist = Object.keys(this.groupDomainMapChinese).find(d => this.groupDomainMapChinese[d]?.includes(row.Domain))
        } else {
          exist = Object.keys(this.groupDomainMapChinese).find(d => this.groupDomainMapChinese?.includes(row.Domain))
        }
        // let exist = Object.keys(this.groupDomainMapChinese).find(d => this.groupDomainMapChinese[d] === row.Domain || this.groupDomainMapChinese === row.Domain);
        if (exist) {
          mapDomain = row.Domain + ' ' + exist
        }
      }

      let copy = 0

      if (this.userMain || this.mode === 'New') {
        this.groupDomain = this.groupDomain.map(m => {
          let domainSlot = m.Domain?.normalize().replace(/[\s，、（）]/g, '')
          let postDomain = mapDomain?.normalize().replace(/[\s，、（）]/g, '')
          if (domainSlot?.includes(postDomain)) {
            if (m.Comment !== '' && m.Comment !== undefined && m.Comment !== null) {
              m.Comment = m.Comment + '\n' + row.Indicator
              copy++
            } else {
              m.Comment = row.Indicator
              copy++
            }
          }
          const htmlTagsRegex = /<[^>]+>/g
          m.Comment?.replace(htmlTagsRegex, '')
          m.Comment = m.Comment?.replace(htmlTagsRegex, '')
          return m
        })
        if (copy > 0) {
          this.$notify.success({
            title: 'Successfully',
            message: 'Successfully Copy...',
          })
        } else {
          this.$notify.error({
            title: 'Unsuccessful',
            message: 'No Domain To Paste...',
          })
        }
      } else {
        if (this.singleComment === '') {
          this.singleComment = row.Indicator
        } else {
          this.singleComment = this.singleComment + '\n' + row.Indicator
        }

        this.$notify.success({
          title: 'Successfully',
          message: 'Successfully Copy...',
        })
      }
    },

    fnCurrentClassStudentName() {
      this.currentClassStudentName = 'Error'

      let currentClassID = this.ddlClass.split(',')
      let currentClassName = this.ddlClassList.filter(m => m.PK_Class_ID === currentClassID[2])

      let currentStudentName = this.dllStudentList.filter(m => m.Student_ID === this.ddlStudent)

      this.currentClassStudentName = currentClassName[0].CLS_ClassName
      this.currentClassStudentName += ' > ' + currentStudentName[0].First_Name

      if (currentStudentName[0].Middle_Name !== '') {
        this.currentClassStudentName += ' ' + currentStudentName[0].Middle_Name
        this.currentClassStudentName += ' ' + currentStudentName[0].Last_Name
      } else {
        this.currentClassStudentName += ' ' + currentStudentName[0].Last_Name
      }
    },

    addTeacher() {
      if (this.ddlClassTeacher === '') {
        this.$notify({
          title: 'Required',
          message: 'Please select teacher...',
        })
      } else if (this.inputTeacherType === '') {
        this.$notify({
          title: 'Required',
          message: 'Please key in teacher role',
        })
      } else {
        //check if teacher added
        let check = this.selectedTeacherList.filter(m => m.ID === this.ddlClassTeacher)

        if (check.length < 1) {
          //get teacher name
          let currentTeacherInfo = this.classTeacherList.filter(m => m.CONid === this.ddlClassTeacher)

          if (currentTeacherInfo.length > 0) {
            let currentTeacher = {
              ID: this.ddlClassTeacher,
              Name: currentTeacherInfo[0].CONname,
              Type: this.inputTeacherType,
              Checked: this.checkedTeacher,
            }

            this.selectedTeacherList.push(currentTeacher)

            this.ddlClassTeacher = ''
            this.inputTeacherType = ''
            this.checkedTeacher = false
          }
        } else {
          this.$notify.error({
            title: 'Invalid',
            message: 'This Teacher have been added...',
          })
        }
      }
    },
    deleteTeacher(value) {
      this.selectedTeacherList = this.selectedTeacherList.filter(m => m.ID !== value.ID)
    },
    showPublishedReport() {
      this.showPublishTermlyReport = true
    },
    hidePublishedReport() {
      this.showPublishTermlyReport = false
      this.clear('All')
    },

    adddeleteLanguageTeacher(value) {
      if (value.RoleType === 'LanguageTeacher') {
        this.teacherAndApproverList = this.teacherAndApproverList.map(m => {
          if (m.ConID === value.ConID && m.Role === value.Role) {
            if (m.RoleType === 'LanguageTeacher') {
              if (value.RoleTypeActive === 'Yes') {
                m.RoleTypeActive = 'No'
              } else {
                m.RoleTypeActive = 'Yes'
              }
            }
          }

          return m
        })
      } else {
        this.$notify.error({
          title: 'Invalid',
          message: 'Invalid Action...',
        })
      }
    },

    termlyReportTourStart() {
      this.tourRunning = true
      this.$tours['termlyReportTourName'].start()
    },
    termlyReportNexPreviousStep(tour, nextOrPreviousStep) {
      let nextStep = 0

      if (tour.currentStep === 1 && nextOrPreviousStep === 'Next') {
        if (this.ddlClass === '' || this.ddlStudent === '') {
          return
        } else if (this.ddlClass.toUpperCase().includes('ERROR')) {
          return
        }
      } else if (tour.currentStep === 2 && nextOrPreviousStep === 'Next') {
        if (this.ddlClass === '' || this.ddlStudent === '') {
          this.$tours['termlyReportTourName'].currentStep = 0
          return
        } else if (this.ddlClass.toUpperCase().includes('ERROR')) {
          this.$tours['termlyReportTourName'].currentStep = 0
          return
        } else {
          this.action('New', '')
        }
      } else if (tour.currentStep === 3 && nextOrPreviousStep === 'Previous') {
        return
      }

      if (nextOrPreviousStep === 'Next') {
        tour.nextStep()
        nextStep = tour.currentStep + 1
      } else if (nextOrPreviousStep === 'Previous') {
        tour.previousStep()
        nextStep = tour.currentStep - 1
      } else if (nextOrPreviousStep === 'Stop') {
        this.tourRunning = false
        tour.stop()
        nextStep = 9999
      }
    },
    termlyReportEditTourStart() {
      this.tourRunning = true
      this.$tours['termlyReportEditTourName'].start()
    },
    termlyReportEditNexPreviousStep(tour, nextOrPreviousStep) {
      let nextStep = 0
      this.divEditListRedBorder = false

      if (nextOrPreviousStep === 'Next') {
        tour.nextStep()
        nextStep = tour.currentStep + 1
      } else if (nextOrPreviousStep === 'Previous') {
        tour.previousStep()
        nextStep = tour.currentStep - 1
      } else if (nextOrPreviousStep === 'Stop') {
        this.tourRunning = false
        tour.stop()
        nextStep = 9999
      }

      if (nextStep >= 2 && nextStep <= 4) {
        this.divEditListRedBorder = true
      }
    },
  },
  computed: {
    isLocalDevUser() {
      return store.state.devAccess.isLocalDevUser
    },
    isPNN1() {
      let levelID = this.ddlClass.split(',')
      let selectedClass = this.ddlClassList?.find(d => d.CLS_FK_Course_ID === this.reportLevel || d.CLS_FK_Course_ID === levelID?.[1])
      return (
        selectedClass?.CLS_ClassName.includes('Pre-Nursery') ||
        selectedClass?.CLS_ClassName?.includes('Nursery 1') ||
        selectedClass?.CLS_FK_Course_ID === 'CRS201400125' ||
        selectedClass?.CLS_FK_Course_ID === 'CRS201400111'
      )
    },
    isInfantCare() {
      let levelID = this.ddlClass.split(',')
      const courseId = this.reportLevel || levelID?.[1]
      return courseId === 'CRS201400072'
    },
  },
}
</script>

<style lang="scss" scoped>
@import './termly';
</style>

<style>
#termlyreport .slClass .el-input__inner,
#termlyreport .slStudent .el-input__inner,
#termlyreport .ddlFilterPostType .el-input__inner,
#termlyreport .slTeacher .el-input__inner {
  color: #426dff;
  background: #ffffff;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 5px;
}

#termlyreport .reportAreaContentPart2Header .el-textarea__inner {
  background: #f8faff;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 5px;
}

#termlyreport .groupInput .el-textarea__inner {
  background: #f8faff;
}

#termlyreport .listTable .el-table__header-wrapper th {
  background: #e9edf7;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #222222;
}

#termlyreport .listTable .el-table__row td,
#portfolio_component .indicatorTable .el-table__empty-block {
  background: #f8faff;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #5f5f5f;
}

.termlyFilter .el-date-editor .el-range-input {
  width: 100px;
}

.termlyFilter .el-range-editor.el-input__inner {
  width: initial;
}

.termlyFilter .el-date-editor .el-range-separator {
  min-width: 25px;
}
</style>
